
import { Exhibit } from '../types';

export const photographyExhibits: Exhibit[] = [
  {
    id: 13,
    numberCode: "401",
    titleEn: "Early Photography",
    titleHe: "צילום מוקדם",
    descriptionEn: "A collection of daguerreotypes and early photographic experiments.",
    descriptionHe: "אוסף של דגרוטיפים וניסיונות צילום מוקדמים.",
    image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 3,
      room: "Photography Hall",
      latitude: 32.0840,
      longitude: 34.7805
    }
  },
  {
    id: 14,
    numberCode: "402",
    titleEn: "Documentary Photography",
    titleHe: "צילום דוקומנטרי",
    descriptionEn: "Powerful images documenting significant historical events.",
    descriptionHe: "תמונות עוצמתיות המתעדות אירועים היסטוריים משמעותיים.",
    image: "https://images.unsplash.com/photo-1554844453-7ea2a562a6c8",
    hasAudio: false,
    hasVideo: true,
    location: {
      floor: 3,
      room: "Photography Hall",
      latitude: 32.0835,
      longitude: 34.7815
    }
  },
  {
    id: 15,
    numberCode: "403",
    titleEn: "Digital Photography Revolution",
    titleHe: "מהפכת הצילום הדיגיטלי",
    descriptionEn: "Exploring how digital technology transformed the art of photography.",
    descriptionHe: "חקר כיצד הטכנולוגיה הדיגיטלית שינתה את אמנות הצילום.",
    image: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 3,
      room: "Photography Hall",
      latitude: 32.0838,
      longitude: 34.7820
    }
  }
];
